import { Avatar, Typography } from "@mui/material"
import React from "react"

const PersonalData = (props) => {
    return (
        <div className=" pt-24">
            <div className="flex items-center justify-center mb-24">
                <Avatar
                    sx={{
                        backgroundColor: 'background.paper',
                        color: 'text.secondary',
                    }}
                    className="avatar text-32 font-bold w-96 h-96"
                // src={user.data.photoURL}
                // alt={user.data.displayName}
                >
                    {/* {user.data.displayName.charAt(0)} */}
                </Avatar>
            </div>
            <div className='text-center mb-48'>
                <Typography>
                    Executive Officer Manager
                </Typography>
                {/* <Typography>
                                {employeeRecord.designation}
                            </Typography> */}
                <Typography className='mb-16'>
                    {"Nolte FZE Dubai Silicon Oasis"}
                </Typography>
                <Typography color="text.secondary">
                    {props.mobile}
                </Typography>
                <Typography color="text.secondary">
                   {props.email}
                </Typography>

            </div>
            {/* <FuseNavigation
                className={clsx('navigation')}
                navigation={EmployeeNavigation.children}
            /> */}
        </div>
    )
}

export default PersonalData


